var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasFeatures)?_c('vm-source',{attrs:{"name":"parquesSource","type":"geojson","options":{ data: this.geoJSON }}},[_c('vm-layer',{attrs:{"type":"fill","name":"parque-fill-color","paint":{
      'fill-color': ['coalesce', ['get', 'color'], '#65938B'],
      'fill-opacity': {
        base: 1,
        stops: [
          [12, 1],
          [14, 0.3],
          [20, 0.1]
        ]
      }
    }},on:{"featureselect":_vm.clickparque}}),_c('vm-layer',{attrs:{"type":"fill","name":"parque-fill-texture","images":_vm.icons,"paint":{
      'fill-pattern': {
        base: 1,
        stops: [
          [10, 'parque_extrapequeno'],
          [12, 'parque_normal'],
          [13, 'parque_normal']
        ]
      },
      'fill-opacity': {
        base: 1,
        stops: [
          [12, 1],
          [13.5, 0]
        ]
      }
    }},on:{"featureselect":_vm.clickparque},scopedSlots:_vm._u([{key:"popupHover",fn:function(slotProps){return [_c('vm-popup',{attrs:{"color":_vm.$get(slotProps, 'features[0].properties.color')}},[_c('small',[_c('i',{staticClass:"vtl vtl-parques"}),_vm._v(" PARQUE")]),_c('div',[_c('b',[_vm._v(_vm._s(_vm.$get(slotProps, "features[0].properties.nome")))])])])]}}],null,false,2433975425)}),_c('vm-layer',{attrs:{"type":"line","name":"parque-lines","layout":{
      'line-join': 'round',
      'line-cap': 'round'
    },"paint":{
      'line-color': ['get', 'color'],
      'line-width': {
        base: 1,
        stops: [
          [11, 1],
          [15, 2]
        ]
      },
      'line-opacity': {
        base: 1,
        stops: [
          [10, 1],
          [14, 1]
        ]
      }
    }}}),_c('vm-layer',{attrs:{"type":"line","name":"parque-select-line","filter":['==', ['get', 'id'], _vm.currentParqueID],"layout":{
      'line-join': 'round',
      'line-cap': 'round'
    },"paint":{
      'line-dasharray': {
        base: 1,
        stops: [
          [11, [5, 3]],
          [15, [1, 2]]
        ]
      },
      'line-color': 'yellow',
      'line-width': {
        base: 1,
        stops: [
          [11, 2],
          [15, 2]
        ]
      },
      'line-opacity': {
        base: 1,
        stops: [
          [10, 1],
          [14, 1]
        ]
      }
    }}}),_c('vm-layer',{attrs:{"type":"symbol","name":"parque-centroide","source":{
      type: 'geojson',
      data: _vm.parquesCentroidesGeoJSON
    },"images":{ icon_parque: '/images/icon-parque.png' },"paint":{
      'text-color': 'white',
      'text-halo-color': 'white',
      'text-halo-width': 0.4,
      'text-halo-blur': 0.2,
      'text-opacity': {
        base: 1,
        stops: [
          [10, 0],
          [11, 1],
          [15, 1]
        ]
      },
      'icon-opacity': {
        base: 1,
        stops: [
          [14, 1],
          [15, 1]
        ]
      }
    },"layout":{
      'icon-image': 'icon_parque',
      'icon-anchor': 'bottom',
      'icon-allow-overlap': false,
      'text-field': '{nome}',
      'text-anchor': 'top',
      'text-line-height': 1,
      'text-optional': true,
      'text-offset': {
        base: 1,
        stops: [
          [17, [0, 1.5]],
          [19, [0, 3]]
        ]
      },
      'text-padding': 0,
      'text-size': {
        base: 1,
        stops: [
          [10, 12],
          [14, 12]
        ]
      },
      'icon-size': {
        base: 1,
        stops: [
          [11, 0.3],
          [14, 0.5]
        ]
      }
    }}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }